


import api from '../../api/index.js'

const state = {

}

const getters = {

}

const actions = {
    // 获取搜索集合
    GetImageManageImageList({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/ImageManage/GetImageList',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
}

const mutations = {

}

export default {
    state,
    getters,
    actions,
    mutations
}
